/**
 * ScoreRing.jsx — iter847 (Feb 2026)
 * Extracted from BreastHealthIntelligencePage.jsx. Circular metabolic
 * score visual (0–100) with band-coloured stroke and honest "no data"
 * state when backend returns null / insufficient_data.
 */
import React from "react";
import { motion } from "framer-motion";

export default function ScoreRing({ score, band, lang }) {
  const radius = 60;
  const stroke = 12;
  const circ = 2 * Math.PI * radius;
  const isEmpty = score == null || band === "insufficient_data";
  const dash = isEmpty ? 0 : (score / 100) * circ;
  const colors = { green: "#22C55E", yellow: "#EAB308", orange: "#F97316", red: "#EF4444" };
  return (
    <div className="relative" style={{ width: 160, height: 160 }} data-testid="metabolic-score-ring">
      <svg width="160" height="160" viewBox="0 0 160 160">
        <circle cx="80" cy="80" r={radius} stroke="rgba(0,0,0,0.06)" strokeWidth={stroke} fill="none" />
        {!isEmpty && (
          <motion.circle
            cx="80" cy="80" r={radius}
            stroke={colors[band] || "#EAB308"}
            strokeWidth={stroke}
            strokeLinecap="round"
            fill="none"
            strokeDasharray={`${dash} ${circ - dash}`}
            transform="rotate(-90 80 80)"
            initial={{ strokeDasharray: `0 ${circ}` }}
            animate={{ strokeDasharray: `${dash} ${circ - dash}` }}
            transition={{ duration: 1.2, ease: "easeOut" }}
          />
        )}
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        {isEmpty ? (
          <>
            <div className="text-2xl font-extrabold opacity-40">—</div>
            <div className="text-[10px] opacity-60 text-center px-2 mt-1">
              {lang === "bg" ? "Няма данни" : lang === "es" ? "Sin datos" : "No data"}
            </div>
          </>
        ) : (
          <>
            <div className="text-4xl font-extrabold">{score}</div>
            <div className="text-[10px] opacity-60">/ 100</div>
          </>
        )}
      </div>
    </div>
  );
}
